if (!customElements.get('quick-cart-drawer')) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
        this.parentElement.addEventListener('shopify:section:select', () => this.open());
        this.parentElement.addEventListener('shopify:section:deselect', () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }

      this.querySelector('.button--close').addEventListener('click', this.close.bind(this));
      this.querySelector('.quick-cart-drawer__backdrop').addEventListener('click', this.close.bind(this));

      this.querySelector('.quick-cart-drawer__blocks').addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === 'Tab';

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll('.quick-cart-drawer__trigger').forEach(element => {
          if (!element._init) {
            element.addEventListener('click', event => {
              this.fetchProductForQuickCartDrawer(event);
            });
            element._init = true; 
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    // ========================================================
    // FILTRO REPARADO: ELIMINA HUECOS Y ANCLA AL INICIO (POS 0)
    // ========================================================
    filterDrawerGallery(optionsArray) {
      if (!optionsArray || optionsArray.length === 0) return;
      const mediaSlides = this.querySelectorAll('.quick-cart-drawer__media-swiper .swiper-slide');
      
      mediaSlides.forEach((slide) => {
        const img = slide.querySelector('img');
        if (img) {
           const altText = (img.getAttribute('alt') || '').toLowerCase();
           const isGlobalInfo = altText.includes('informacion del producto') || altText.includes('información del producto');
           let matchesColor = false;
           
           optionsArray.forEach(opt => {
              if (opt && opt.length > 2 && (altText.includes(opt) || altText.includes(`[color:${opt}]`))) {
                 matchesColor = true;
              }
           });
           
           if (matchesColor || isGlobalInfo) {
              // Muestra la imagen y restaura sus dimensiones
              slide.style.setProperty('display', '', 'important');
              slide.style.setProperty('margin-right', '', 'important');
              slide.style.setProperty('width', '', 'important');
           } else {
              // Oculta la imagen, anula su ancho y sus márgenes para que NO empuje el carrusel
              slide.style.setProperty('display', 'none', 'important');
              slide.style.setProperty('margin-right', '0px', 'important');
              slide.style.setProperty('width', '0px', 'important');
           }
        }
      });
      
      if (this.sliderInstance) {
         this.sliderInstance.update();
         // TRUCO MAESTRO: Forzar siempre a la posición absoluta 0.
         // Al no tener márgenes las fotos anteriores, el inicio siempre será perfecto.
         this.sliderInstance.slideTo(0, 0);
         this.sliderInstance.setTranslate(0);
      }
    }

    async fetchProductForQuickCartDrawer(event) {
      if (event.target.closest('card-product-slider')) {
        event.target.closest('card-product-slider').slider.autoplay.stop();
        event.target.closest('card-product-slider').classList.add('product--open-on-quick-cart');
      }

      const isRecommendations = event.target.classList.contains('quick-cart-drawer__trigger--recommendations');
      const trigger = event.target.closest('[data-product-url]');
      if (!trigger) return;
      
      const targetColorRaw = trigger.getAttribute('data-card-color') || '';
      const targetColor = targetColorRaw.toLowerCase().trim();

      trigger.classList.toggle('is--loading');
      
      try {
        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }
        
        let fetchUrl = `${fetchPrefix}${trigger.dataset.productUrl}`;
        if (!fetchUrl.includes('?')) {
            fetchUrl += '?view=quick-cart';
        } else {
            fetchUrl += '&view=quick-cart';
        }

        const productCardResponse = await fetch(fetchUrl);
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const productCard = document.createElement('DIV');
        productCard.insertAdjacentHTML('beforeend', productCardHTML);
        
        if (!productCard.querySelector('.quick-cart-product')) return;
        this.querySelector('.quick-cart-drawer__main').innerHTML = '';
        this.querySelector('.quick-cart-drawer__main').append(productCard.querySelector('.quick-cart-product'));

        this.sliderInstance = new Swiper('.quick-cart-drawer__media-swiper', {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: { enabled: true },
          breakpoints: { 750: { slidesPerView: 2 } }
        });

        if (!isRecommendations) {
          const quickCartForm = this.querySelector('product-card');
          if (quickCartForm) {
            const submitBtn = quickCartForm.querySelector('button[type="submit"]');
            const mainHiddenInput = quickCartForm.querySelector('input[name="id"]');
            
            quickCartForm.querySelectorAll('input[type="radio"]').forEach(radio => {
              radio.checked = false;
              if (radio.closest('li')) radio.closest('li').classList.remove('checked');
            });

            if (targetColor) {
               const allRadios = quickCartForm.querySelectorAll('input[type="radio"]');
               allRadios.forEach(radio => {
                  if (radio.value.toLowerCase().trim() === targetColor) {
                     radio.checked = true;
                     if (radio.closest('li')) radio.closest('li').classList.add('checked');
                     
                     const label = radio.closest('fieldset').querySelector('legend [data-selected-variant]');
                     if(label) label.textContent = radio.value;
                  }
               });
            }

            if (submitBtn) {
              submitBtn.setAttribute('disabled', 'disabled');
              submitBtn.textContent = 'Selecciona una talla'; 
            }
            if (mainHiddenInput) {
              mainHiddenInput.value = ''; 
            }

            quickCartForm.init();
          }
        }

        if (targetColor) {
           this.filterDrawerGallery([targetColor]);
        }

      } catch (error) {
        console.error(error);
      } finally {
        trigger.classList.remove('is--loading');

        setTimeout(() => {
          this.open();
        }, 500);

        this.querySelector('.quick-cart-drawer__main')
          .querySelectorAll('.variant-option-radio-input')
          .forEach(radioInput => {
            radioInput.addEventListener('change', event => {
              const quickCartDrawerOptionLabel = event.target.closest('fieldset').querySelector('legend');
              const quickCartDrawerOptionLabelSpan = quickCartDrawerOptionLabel?.querySelector('[data-selected-variant]');
              if (quickCartDrawerOptionLabelSpan) {
                quickCartDrawerOptionLabelSpan.innerHTML = event.target.value;
              }

              const card = this.querySelector('product-card');
              if (card && card.variantsObj) {
                  const fieldsets = card.querySelectorAll('fieldset');
                  let allOptionsSelected = true;
                  let selectedOptions = [];

                  fieldsets.forEach(fieldset => {
                     const checked = fieldset.querySelector('input[type="radio"]:checked');
                     if(!checked) allOptionsSelected = false;
                     else selectedOptions.push(checked.value.toLowerCase().trim());
                  });

                  this.filterDrawerGallery(selectedOptions);

                  const submitBtn = card.querySelector('button[type="submit"]');
                  
                  if(allOptionsSelected) {
                     const matchedVariant = card.variantsObj.find(v => {
                        return selectedOptions.every(opt => {
                            return [v.option1, v.option2, v.option3].some(val => val && val.toLowerCase().trim() === opt);
                        });
                     });

                     if(matchedVariant) {
                        const mainInput = card.querySelector('input[name="id"]');
                        if(mainInput) mainInput.value = matchedVariant.id;
                        
                        if(submitBtn) {
                           if(matchedVariant.available) {
                              submitBtn.removeAttribute('disabled');
                              submitBtn.innerHTML = `<span>Añadir al carrito</span>`; 
                           } else {
                              submitBtn.setAttribute('disabled', 'disabled');
                              submitBtn.innerHTML = `<span>Agotado</span>`;
                           }
                        }

                        // ========================================================
                        // APAGADO: Evitamos que el tema intente hacer scroll a la 
                        // posición original absoluta, rompiendo nuestro alineamiento.
                        // ========================================================
                        /*
                        if (matchedVariant.featured_media) {
                          this.setActiveMedia(matchedVariant.featured_media.id);
                        }
                        */
                     }
                  } else {
                     if(submitBtn) {
                        submitBtn.setAttribute('disabled', 'disabled');
                        submitBtn.textContent = 'Selecciona una talla';
                     }
                  }
              }
            });
          });
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll('[data-media-id]')).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector('body').classList.add('overflow-hidden');
      const quickCartDrawer = document.querySelector('.quick-cart-drawer__blocks');
      const closeButton = quickCartDrawer.querySelector('.button--close');
      quickCartDrawer.setAttribute('tabindex', '0');
      closeButton.setAttribute('tabindex', '0');
      this.classList.add('is--open');
      this.opened();

      const firstFocusableElement = this.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      this.toggleState = false;

      const shopTheLookDrawer = document.querySelector('shop-the-look-drawer');

      if (shopTheLookDrawer && !shopTheLookDrawer.classList.contains('is--open')) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      if (!shopTheLookDrawer) {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
      this.classList.remove('is--open');
      this.closed();
      this.toggleAriaExpanded();

      if (document.querySelector('card-product-slider.product--open-on-quick-cart')) {
        document.querySelector('card-product-slider.product--open-on-quick-cart').slider.autoplay.start();
        document.querySelector('card-product-slider.product--open-on-quick-cart').classList.remove('product--open-on-quick-cart');
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest('button')) event.target.closest('button').setAttribute('aria-expanded', true);
        this.querySelector('.button--close').setAttribute('aria-expanded', true);
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach(button => {
          button.setAttribute('aria-expanded', false);
        });
      }
    }

    opened() {
      const openedEvent = new Event('opened', { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event('closed', { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define('quick-cart-drawer', QuickCartDrawer);
}